<template>
    <div    class="hg-player player-container" 
            v-if="!!event && !!event.video" 
            @contextmenu="$event.preventDefault()" 
            @mouseup="onMouseUp($event)"
            @mousemove="onMouseMove($event)">
        <video  :id="'video' + event.id" ref="video" xcrossorigin="anonymous" :controls="false"/>
        <canvas-board ref="canvas" v-show="draw_mode" @startDrawing="drawing = true" @stopDrawing="drawing = false"/>
        <!--CONTROL-AREA-->
        <div class="hg-timeline hg-main-timeline" v-if="!draw_mode" :class="{disabled: !!selectedTag, clean: !selectedTag && !editingTag}" 
                                 @mousedown="onTimelineMouseDown($event)"
                                 @mousemove="onTimelineMouseMove($event)">
            <div class="timeline-controls">
                <span   class="tlc-tag" 
                        v-for="tag in event.tags" 
                        :key="tag.id" 
                        :class="{
                            selected: !!selectedTag && tag.id == selectedTag.id,
                            editing: !!editingTag && tag.id == editingTag.id
                        }"
                        :style="{
                            left: computePercentage(tag.start_time) + '%',
                            width: computePercentage(tag.end_time - tag.start_time) + '%',
                            backgroundImage: 'url(' + getTagIcon(tag.tag_type?tag.tag_type.icon:2) + ')'
                        }">
                </span>
                <span class="tlc-current-bar" :style="{width: percentage + '%'}"></span>
            </div>
        </div>
        <div ref="markerTimeline" class="hg-timeline hg-zoomed-timeline hg-selected" v-if="!$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG && !draw_mode && !!selectedTag" 
                                                    @mousedown="onZoomedTimelineMouseDown($event)"
                                                    @mousemove="onZoomedTimelineMouseMove($event)">
            <div class="timeline-controls">
                <span class="tlc-current-bar" :style="{width: selected_tag_percentage + '%'}"></span>
                <span   class="tlc-marker" :title="JSON.stringify(marker,null,4)"
                        v-for="(marker, $index) in selectedTag.markers" 
                        @mousedown.prevent.stop="startMarkerDrag(marker,$index,$event)"
                        :key="marker.id" 
                        :class="{'first': $index == 0, 'last': $index == selectedTag.markers.length - 1}"
                        :style="{
                            left: computePercentageInSelectedTag(marker.ts) + '%'
                        }">
                </span>
            </div>
        </div>
        <div class="hg-timeline hg-zoomed-timeline hg-editing" v-if="!$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG && !draw_mode && !!editingTag">
            <div class="timeline-controls" style="pointer-events: all;" ref="resTimeline">
                <!-- <span class="tlc-current-bar" :style="{
                    position:'relative',
                    width: (editingTag.end_time - editingTag.start_time)*100/10 + '%',
                    left: 25 + '%'
                }">EDITING</span> -->
                <vue-resizable   
                        class="tlc-current-bar"
                        style="pointer-events: all" 
                        :active="['r','l']"
                        :fit-parent="true"
                        @resize:end="onResizeEnd"
                        :left="editing_tag_left"
                        :width="editing_tag_width"
                        >
                        <div class="content">
                            <span class="tag-start">
                                {{editingTag.start_time | sec2time(true)}}
                            </span>
                            <span class="tag-end">
                                {{editingTag.end_time | sec2time(true)}}
                            </span>
                        </div>
                </vue-resizable> 
            </div>
        </div>
        <media-controls class="media-controls"
                        :style="{'pointer-events':drawing?'none':'all'}"
                        :class="{drawing: drawing}"
                        :currentTime="current_time"
                        :duration="duration"
                        :playing="playing"
                        :mode="mode"
                        :selectedResolution="selected_resolution"
                        :actualZoom="actual_zoom"
                        :enableTagClip="enableTagClip"
                        :autozoom="autozoom"
                        :availableResolutions="available_resolutions"
                        :enableDraw="draw_mode"
                        :enablePreview="enable_preview"
                        :enablePZR="enable_pzr"
                        :enableEdit="enableEdit"
                        :enableAutozoom="enableAutozoom"
                        @changeResolution="changeResolution"
                        @play="play" 
                        @pause="pause" 
                        @stop="stop"
                        @edit="$emit('edit')"
                        @download="$emit('download')"
                        @showInfo="$emit('showInfo')"
                        @requestAutozoom="$emit('requestAutozoom')"
                        @toggleTagList="toggleTagList" 
                        @addMarker="addMarker" 
                        @togglePreview="togglePreview" 
                        @zoomIn="zoomIn" 
                        @zoomOut="zoomOut"
                        @zoomTo="zoomTo"
                        @toggleDraw="toggleDraw"
                        @drawUndo="drawUndo"
                        @drawRedo="drawRedo"
                        @drawColor="drawColor"
                        @drawSize="drawSize"
                        @drawMode="drawMode"
                        @drawSave="drawSave"/>
        <table class="table-manager-debug" v-if="manager">
            <tr><th>X</th><td>{{manager.x}}</td></tr>
            <tr><th>Y</th><td>{{manager.y}}</td></tr>
            <tr><th>Z</th><td>{{manager.z}}</td></tr>
            <tr><th>R</th><td>{{manager.r}}</td></tr>
        </table>
    </div>
</template>
<script>
import { CONSTANTS, HELPERS } from "morpheos.hisport.vueplugin"
const MAX_TAG_DURATION = 120; // (2 minutes)
const MODES = {IDLE:undefined,TAG:'tag',MARKER:'marker',DRAW:'draw'};
import VueResizable from "vue-resizable";
import mediaControls from "./media_controls";
import canvasBoard from "./canvas_board";
export default {
    components:{
        VueResizable,
        mediaControls,
        canvasBoard
    },
    props: {
        autozoom: {
            type: Object,
            default: null,
        },
        enableEdit: {
            type: Boolean,
            default: false
        },
        enableAutozoom: {
            type: Boolean,
            default: false
        },
        enableTagClip: {
            type: Boolean,
            default: false
        },
        markerInterval: {
            type: Number,
            default: 1
        },
        markerThresholds: {
            type: Number,
            default: 1
        },
        editMode: {
            type: Boolean,
            default: false
        },
        editingTag: {
            type: Object,
            default: function(){
                return null;
            }
        },
        selectedTag: {
            type: Object,
            default: function(){
                return null;
            }
        },
        tagTypes: {
            type: Array,
            default: function(){ return [] }
        },
        event: {
            type: Object,
            default: function(){
                return null;
            }
        }
    },
    beforeDestroy(){
        this.destroyed = true;
        if(this.player){
            this.player.dispose();
        }
        clearInterval(this.mgr_interval);
        clearInterval(this.markers_rec_interval);
    },
    mounted(){
        var self = this;
        HELPERS.externalLoad('/extended_video_player_lib/video-js.min.css','css', 'videojs-css', function(){
            HELPERS.externalLoad('/extended_video_player_lib/video.min.js','js', 'videojs-js', function(){
            //   HELPERS.externalLoad('/extended_video_player_lib/video-hls.min.js','js', 'videojs-hls-js', function(){
                HELPERS.externalLoad('/extended_video_player_lib/videojs-hisport.js','js', 'videojs-hisport', function(){
                    self.setup()
                        .then(function(){
                            if(!self.destroyed)
                                setTimeout(self.initVideoJS, 100);
                        })
                        .catch(function(){
                            alert("ERROR");
                        })
                    });
                // });
            });
        });
    },
    data(){
        return {
            destroyed:                  false,
            MAX_TAG_DURATION:           MAX_TAG_DURATION,
            MODES:                      MODES,
            previous_current_time:      0,
            previous_play:              false,
            error:                      true,
            loaded:                     false,
            current_time:               0,
            duration:                   0,
            drawing:                    false,
            playing:                    false,
            muted:                      false,
            count:                      0,
            available_resolutions:      [],
            player:                     null,
            manager:                    null,
            enable_preview:             false,
            enable_pzr:                 this.$hisport.options.platform.CONFIGURATION.ENABLE_EVENT_PZR,
            enable_edit:                false,
            draw_mode:                  false,
            timeline_mousedown:         false,
            timeline_zoomed_mousedown:  false,
            editing_tag_start:          0,
            editing_tag_left:           0,
            editing_tag_width:          0,
            selected_resolution:        'hd',
            height:                     undefined,
            width:                      undefined,
            actual_zoom:                1,
            mgr_interval:               null,

            selected_marker:            undefined,
            markers_rec_interval:       null
        }
    },
    methods: {
        startMarkerDrag: function(marker){
            this.selected_marker = marker;
        },
        onMouseMove: function(event){
            if(this.selected_marker && this.$refs.markerTimeline){
                var tml = this.$refs.markerTimeline;
                var ts =  this.selectedTag.start_time + 
                            (this.selectedTag.end_time - this.selectedTag.start_time) * 
                            ((event.clientX - tml.getBoundingClientRect().x) / tml.offsetWidth);
                if(ts < this.selectedTag.start_time) return;
                if(ts > this.selectedTag.end_time) return;

                var markerIndex = this.selectedTag.markers.findIndex(x=>x.id == this.selected_marker.id);
                var maxIndex = this.selectedTag.markers.length - 1;
                if(markerIndex == 0){
                    if(ts > this.selectedTag.markers[1].ts) 
                        return;
                }else if(markerIndex == maxIndex){
                    if(ts < this.selectedTag.markers[maxIndex - 1].ts) 
                        return;
                }else {
                    if(ts < this.selectedTag.markers[0].ts || ts > this.selectedTag.markers[maxIndex].ts) 
                        return
                }
                this.selected_marker.ts = ts;
                this.updateMarkers();
            }
        },
        getTagIcon: function(id){
            var tt = this.tagTypes.find(function(x){ return x.id == id; })
            if(tt)
                return tt.icon;
        },
        getTagTypeName: function(id){
            var tt = this.tagTypes.find(function(x){ return x.id == id; })
            if(tt && tt.name)
                return tt.name[this.$hisport.current_culture];
        },
        startMarkersRecording: function(){
            var self = this;
            this.markers_rec_interval = setInterval(function(){
                if(self.playing){
                    // console.log("RECORDING", this.manager.ts, this.manager.x, this.manager.y);
                    self.addMarker({})
                }else{
                    // console.log("STOPPED");
                    // clearInterval(self.markers_rec_interval);
                    self.stop();
                }
            }, this.markerInterval * 1000);
        },
    //#region "Various"
        onVideoJsSuccess: function(){
            if(this.destroyed) return;
            var hg = this.player.getChild("HiSport");
            this.manager = hg.getManager();
            if(this.$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG){
                this.enable_preview = this.manager.isPreviewActive();
                this.enable_pzr = this.manager.isPZRActive();
            }
            if(Array.isArray(this.event.tags))
                this.event.tags.forEach(this.manager.addTag);
            this.computeEditingTag();
            var self = this;
            this.mgr_interval = setInterval(function(){
                if(!self.manager) return;
                self.actual_zoom = self.manager.z;
            }, 200);
        },
        computeEditingTag: function(){
            if(!this.editingTag) return;
            var delta = MAX_TAG_DURATION - (this.editingTag.end_time - this.editingTag.start_time);
            var editing_tag_start_seconds = Math.max(this.editingTag.start_time - delta/2, 0);
            this.editing_tag_start = editing_tag_start_seconds;
            setTimeout(function(){
                if(!this.$refs || !this.$refs.resTimeline) 
                    return console.error("NO ELEMENT");
                var tot = this.$refs.resTimeline.offsetWidth;
                this.editing_tag_left = (tot * (this.editingTag.start_time - this.editing_tag_start)/MAX_TAG_DURATION); //+ 'px';
                this.editing_tag_width = (tot * (this.editingTag.end_time - this.editingTag.start_time)/MAX_TAG_DURATION); //+ 'px';
            }.bind(this), 50)
        },
        onResizeEnd: function(p){ 
            if(!this.editingTag) return;
            if(!this.$refs.resTimeline) return;
            var tot = this.$refs.resTimeline.offsetWidth;

            var pcLeft = p.left / tot;
            var pcWidth= p.width / tot;
            var round = function(n){
                const PREC = 10;
                return Math.round(n*PREC)/PREC;
            }
            this.editingTag.start_time = round(this.editing_tag_start + pcLeft * MAX_TAG_DURATION);
            this.editingTag.end_time = round(this.editingTag.start_time + pcWidth * MAX_TAG_DURATION);

            this.editing_tag_left = (tot * (this.editingTag.start_time - this.editing_tag_start)/MAX_TAG_DURATION); //+ 'px';
            this.editing_tag_width = (tot * (this.editingTag.end_time - this.editingTag.start_time)/MAX_TAG_DURATION); //+ 'px';
        },
        getActiveElement: function(){
            var videoElement = this.$refs.video;
            if(!document.body.contains(videoElement)){
                if(this.destroyed) return;
                var newVideoElement = document.querySelector("video");
                if(!newVideoElement)
                    console.error("No video element?")
                console.warn("Video element is not the same as ref (???)", videoElement, newVideoElement)
                newVideoElement.controls = false;
                videoElement = newVideoElement;
                this.$refs.video = videoElement;
                this.setup()
                    .then(function(){
                        setTimeout(self.initVideoJS, 100);
                    })
                    .catch(function(){
                        alert("ERROR");
                    })
            }
            return videoElement;
        },
        computePercentage: function(time){
            if(this.duration>0)
                return (time * 100 / this.duration);
            return 0;
        },
        computePercentageInSelectedTag: function(time){
            if(!this.selectedTag) return 0;
            if(time <= this.selectedTag.start_time) return 0;
            if(time >= this.selectedTag.end_time) return 100;
            return (time - this.selectedTag.start_time) * 100 / (this.selectedTag.end_time - this.selectedTag.start_time);
        },
        togglePreview: function(arg){
            if(!this.manager) return;
            this.enable_preview = this.manager.togglePreview(arg);
        },
        // togglePZR: function(arg){
        //     if(!this.manager) return;
        //     this.enable_pzr = this.manager.togglePZR(arg);
        //     this.toggleMarkerEdit(this.enable_pzr && !this.editMode);
        // },
        toggleMarkerEdit: function(arg){
            if(!this.manager) return;
            this.enable_edit = this.manager.toggleMarkerEdit(arg);
            var self = this;
            console.log("toggleMarkerEdit", this.enable_edit)
            if(this.enable_edit){
                setTimeout(function(){
                    var s = self.manager.size;
                    self.manager.set({z: Math.max(s.z_x, s.z_y) });
                }, 500)
            }else{
                setTimeout(function(){
                    self.manager.set({z: 1 });
                }, 500)
            }
        },
        toggleTagList: function($event){
            this.$emit("toggleTagList",$event);
        },
        changedEditMode: function(){
            var ele = this.getActiveElement();
            this.togglePreview(false);
            if(this.editMode){
                ele.pause();
                ele.currentTime = this.selectedTag.start_time + 0.00001;
                this.toggleMarkerEdit(true);
            }else{
                ele.pause();
                this.toggleMarkerEdit(false);
            }
        },
        getOptions: function(){
            return this.manager.getOptions();
        },
    //#endregion
    //#region "VideoJS and other setup utilities"
        computePlayerSize(){
            var videoElement = this.getActiveElement();
            if(!videoElement) return console.warn("No video el during resize");
            if(!this.$el) return console.error("No $el during resize");
            try{
                var o_width     = videoElement.offsetWidth;
                var o_height    = videoElement.offsetHeight;
                if(!o_width || !o_height){
                    return console.error("Invalid videoElement size", videoElement);
                }

                var width = this.$el.offsetWidth; // - 80;
                var height = o_height * width/o_width;
                if(height > window.innerHeight){
                    height = window.innerHeight;
                    width = o_width * height/o_height;
                }
                this.player.width(width); 
                this.player.height(height);
                var self = this;
                setTimeout(function(){
                    self.$el.style.overflow = "hidden";
                    self.$el.style.height = height + "px";
                },100)
            }catch(ex){
                console.error("Exception during resize", ex);
            }
        },
        initVideoJS(){
            var self = this;
            var videoElement = self.$refs.video;
            // var d_ratio     = CONSTANTS.CLIP_SIZE.WIDTH/CONSTANTS.CLIP_SIZE.HEIGHT;
            
            var o_width     = videoElement.offsetWidth;
            var o_height    = videoElement.offsetHeight;
            //var o_ratio     = o_width/o_height;

            var v_width     = videoElement.videoWidth;
            var v_height    = videoElement.videoHeight;
            var v_ratio     = v_width/v_height;

            var width       = self.event.video.width;
            var height      = self.event.video.height;

            videoElement.classList.add("video-js")
            videoElement.classList.add("vjs-default-skin");
            this.player = window.videojs('video' + self.event.id, 
                                        { 
                                            inactivityTimeout: 0,
                                            controlBar: {
                                                fullscreenToggle: false
                                            },
                                            markers: self.autozoom && self.autozoom.results
                                        }, 
                                        function () {
                                            if(self.destroyed) return;
                                            var resizeTimeout = null;
                                            window.addEventListener("resize", function () {
                                                clearTimeout(resizeTimeout);
                                                self.$el.style.height = "auto";
                                                resizeTimeout = setTimeout(function(){
                                                    self.computeEditingTag();
                                                    self.computePlayerSize(o_height,o_width);
                                                }, 100)
                                            });
                                        });

            window.player = this.player;
            this.player.width(o_width); 
            this.player.height(o_width * 1/v_ratio);

            this.computePlayerSize(o_height,o_width);
            var opts = {
                rotate:         0,
                size:           {
                    z_x: width/CONSTANTS.CLIP_SIZE.WIDTH, 
                    z_y: height/CONSTANTS.CLIP_SIZE.HEIGHT 
                },
                z:              this.actual_zoom, //width/CONSTANTS.CLIP_SIZE.WIDTH,
                x:              0,
                y:              0,
                clickToToggle:  false,
                preview:        false,
                hide_pzr:       false,
                markerThresholds: this.markerThresholds,
                markerInterval: this.markerInterval
            };
            this.player.hisport(opts);
            setTimeout(this.onVideoJsSuccess,500)
        },
        setup: function(){
            var self = this;
            return new Promise(function(resolve, reject){
                var _setup = function(){
                    self.setupPreviewBox()
                        .then(function(){
                            self.loaded = true;
                            return resolve();
                        })
                        .catch(function(){
                            self.count++;
                            if(self.count>10){
                                self.loaded = true;
                                reject();
                                return self.error = true;
                            }
                            setTimeout(_setup, 100)
                        })
                }
                _setup();
            })
        },
        changeDuration: function(d){
            if(this.duration != d){
                console.log("changeDuration", d);
                this.$emit("duration", d);
                this.duration = d;
            }
        },
        changeCurrentTime: function(ct){
            // console.log("changeCurrentTime", ct, this.current_time);
            if(this.current_time != ct){
                this.$emit("currentTime", ct);
                this.current_time = ct;
            }
        },
        setupPreviewBox: function(){
            var self = this;
            return new Promise(function(resolve, reject){
                clearInterval(self.autozoom && self.autozoom.interval);
                var ele = self.$refs.video;
                if(!ele) {
                    return reject("ERROR")
                }
                var resolved = false;
                ele.addEventListener("error", function(){
                    clearInterval(self.autozoom && self.autozoom.interval);
                    console.error("Error", arguments);
                })
                ele.addEventListener("timeupdate", function(){
                    if(!isNaN(this.duration))
                        self.changeDuration(this.duration);
                    if(!isNaN(this.currentTime))
                        self.changeCurrentTime(this.currentTime);
                    if(self.selectedTag && !self.$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG ){
                        if(self.editMode){
                            if(self.current_time < self.selectedTag.markers[0].ts){
                                this.currentTime = self.selectedTag.markers[0].ts;
                                this.pause();
                            }else if(self.current_time > self.selectedTag.markers[self.selectedTag.markers.length - 1].ts){
                                this.currentTime = self.selectedTag.markers[self.selectedTag.markers.length - 1].ts;
                                this.pause();
                            }
                        }else{
                            if(self.current_time < self.selectedTag.start_time){
                                this.currentTime = self.selectedTag.start_time;
                                this.pause();
                            }else if(self.current_time > self.selectedTag.end_time){
                                this.currentTime = self.selectedTag.end_time;
                                this.pause();
                            }
                        }
                    }
                });
                ele.addEventListener("play", function(){
                    var v = this;
                    console.log("play");
                    self.playing = true;
                    if (self.autozoom && Array.isArray(self.autozoom.results) && self.autozoom.results.length > 0){
                        var _do = function(){
                            self.manager.clearMarkers();
                            var range = self.autozoom.results
                                            .filter(function(x){
                                                return x.ts >= v.currentTime && x.ts <= (v.currentTime + 60);
                                            })
                            range.forEach(function(m){
                                self.manager.addMarker(m)
                            })
                        }
                        self.autozoom.interval = setInterval(_do, 40000);
                        _do();
                    }
                });
                ele.addEventListener("pause", function(){
                    console.log("pause");
                    self.playing = false;
                    clearInterval(self.autozoom && self.autozoom.interval);
                });
                ele.addEventListener("volumechange", function(){
                    console.log("volumechange");
                    self.muted = ele.muted
                });
                ele.addEventListener("DOMAttrModified", function(event) {
                    console.log("DOMAttrModified");
                    if (event.attrName == "src") {
                        self.changeDuration(event.target.duration);
                        self.changeCurrentTime(0)
                        if(!resolved){
                            resolved = true;
                            return resolve();
                        }
                    }
                });
                ele.addEventListener("loadedmetadata", function(event) {
                    console.log("loadedmetadata", self.previous_current_time);
                    self.changeDuration(event.target.duration);
                    // self.current_time = self.previous_current_time || 0;
                    self.changeCurrentTime(self.current_time);
                    this.currentTime = self.previous_current_time || 0;
                    if(self.previous_play)
                        this.play();
                    self.previous_current_time = 0;
                    self.previous_play = false;
                    console.log(self.$refs.video, this)
                    if(!resolved){
                        resolved = true;
                        return resolve();
                    }
                });
                setTimeout(function(){
                    self.changeResolution("hd");
                },10) 
            })
        },
        changeVideo(videoEntity, resolution){
            if(!videoEntity) return;
            this.previous_play = this.playing;
            this.previous_current_time = this.current_time;
            if(this.available_resolutions.length == 0)
                this.available_resolutions = HELPERS.getAvailableResolutions(videoEntity);
            if(!resolution || this.available_resolutions.indexOf(resolution) < 0)
                resolution = this.available_resolutions[0];
            this.selected_resolution = resolution;
            var url = HELPERS.getVideoUrl(videoEntity, resolution);
            if(this.event.video.preview_url)
                this.$refs.video.poster = this.$hisport.absolute(videoEntity.preview_url, {default:'/images/event_default.png', w: 1280, q: 80, f: 'jpeg'});
            this.$refs.video.src = url;
            this.playing = false;
        },
        changeResolution(resolution){
            this.changeVideo(this.event.video, resolution);
        },
    //#endregion
    //#region "Zoomed timeline"
        onZoomedTimelineMouseDown: function(event){
            var rightclick;
            if (event.which) rightclick = (event.which == 3);
            else if (event.button) rightclick = (event.button == 2);
            if(rightclick) return;
            if(!this.selectedTag) return;
            var ele = this.getActiveElement();
            if(ele){
                ele.currentTime = this.selectedTag.start_time + (this.selectedTag.end_time - this.selectedTag.start_time) * event.offsetX / event.target.clientWidth
                this.changeCurrentTime(ele.currentTime);
            }
            this.timeline_zoomed_mousedown = true;
        },
        onZoomedTimelineMouseMove: function(event){
            if(!this.timeline_zoomed_mousedown)
                return;
            var rightclick;
            if (event.which) rightclick = (event.which == 3);
            else if (event.button) rightclick = (event.button == 2);
            if(rightclick) return;
            if(!this.selectedTag)
                return;
            var ele = this.getActiveElement();
            if(ele){
                ele.currentTime = this.selectedTag.start_time + (this.selectedTag.end_time - this.selectedTag.start_time) * event.offsetX / event.target.clientWidth
                this.changeCurrentTime(ele.currentTime);
            }
        },
        onMouseUp: function(/*event*/){
            this.timeline_mousedown = false;
            this.timeline_zoomed_mousedown = false;
            this.selected_marker = undefined;
        },
    //#endregion
    //#region "Regular timeline"
        onTimelineMouseDown: function(event){
            var rightclick;
            if (event.which) rightclick = (event.which == 3);
            else if (event.button) rightclick = (event.button == 2);
            if(rightclick) return;
            if(this.selectedTag)
                return;
            var ele = this.getActiveElement();
            if(ele){
                ele.currentTime = ele.duration * event.offsetX / event.target.clientWidth;
                this.changeCurrentTime(ele.currentTime);
            }
            this.timeline_mousedown = true;
        },
        onTimelineMouseMove: function(event){
            if(!this.timeline_mousedown)
                return;
            var rightclick;
            if (event.which) rightclick = (event.which == 3);
            else if (event.button) rightclick = (event.button == 2);
            if(rightclick) return;
            if(this.selectedTag)
                return;
            var ele = this.getActiveElement();
            if(ele){
                ele.currentTime = ele.duration * event.offsetX / event.target.clientWidth
                this.changeCurrentTime(ele.currentTime);
            }
        },
    //#endregion
    //#region "Video player handlers (play, mute, ...)"
        play: function(){
            console.log("PLAY")
            this.draw_mode = false;
            var ele = this.getActiveElement();
            if(ele && typeof ele.play == "function"){
                if(this.editMode && !this.enable_preview){
                    var start = this.selectedTag.start_time;
                    if( this.selectedTag && 
                        Array.isArray(this.selectedTag.markers) && 
                        this.selectedTag.markers.filter(x=>!x.locked).length){
                        var self = this;
                        return this.$modal.show(
                            ()=>import("../hg_prompt"), 
                            { 
                                question: "CONFIRM_RESET_MARKERS", 
                                onConfirm: function(){
                                    self.selectedTag.markers.splice(0);
                                    var mrkrs = self.selectedTag.markers.filter(x=>x.locked);
                                    var startMarker = mrkrs[0];
                                    if(startMarker){
                                        start = startMarker.ts;
                                        startMarker.x = self.manager.x;
                                        startMarker.y = self.manager.y;
                                        startMarker.z = self.manager.z;
                                        startMarker.r = self.manager.r;
                                    }
                                    mrkrs.forEach(self.addMarker);
                                    self.updateMarkers();
                                    self.changeCurrentTime(start);
                                    self.startMarkersRecording();
                                    ele.play();
                                },
                                onDeny: function(){}
                            }
                        );
                    }else{
                        this.addMarker({});
                    }
                    this.changeCurrentTime(start);
                    this.startMarkersRecording();
                }
                ele.play();
            }
        },
        stop: function(){
            console.log("STOP")
            var lastMarker = this.selectedTag.markers[this.selectedTag.markers.length - 1];
            if(this.playing){
                lastMarker.ts = this.current_time;
            }else{
                clearInterval(this.markers_rec_interval);
            }
            lastMarker.x = this.manager.x;
            lastMarker.y = this.manager.y;
            lastMarker.z = this.manager.z;
            lastMarker.r = this.manager.r;
            var ele = this.getActiveElement();
            if(ele && typeof ele.pause == "function"){
                ele.pause();
                ele.currentTime = this.selectedTag.markers[0].ts;
            }
            this.changeCurrentTime(this.selectedTag.markers[0].ts);
            this.updateMarkers();
        },
        pause: function(){
            console.log("PAUSE")
            var ele = this.getActiveElement();
            if(ele && typeof ele.pause == "function"){
                ele.pause();
            }
        },
        mute: function(){
            var ele = this.getActiveElement();
            if(ele){
                ele.muted = true;
            }
        },
        unmute: function(){
            var ele = this.getActiveElement();
            if(ele){
                ele.muted = false;
            }
        },
    //#endregion
    //#region "Canvas board"
        getCurrentFrameAsImage: function(){
            var self = this;
            return new Promise(function(resolve, reject){
                var video       = self.getActiveElement()
                var options     = self.getOptions();
                var vw          = video.videoWidth;
                var vh          = video.videoHeight;
                var z           = self.manager.z;
                var sw          = vw/z;
                var sh          = vh/z;
                var px          = (1-(self.manager.x + options.max_x)/(2 * options.max_x));
                var py          = (1-(self.manager.y + options.max_y)/(2 * options.max_y));
                var sx          = (vw - sw) * px;
                var sy          = (vh - sh) * py;
                if(isNaN(sx)) sx = 0;
                if(isNaN(sy)) sy = 0;
                self.$refs.canvas.clear(true);
                self.$refs.canvas.init(sw * 2, sh * 2);
                // self.$refs.canvas.getCurrentFrameAsImage(video, sx, sy, sw, sh, 0, 0, sw * 2, sh * 2)
                // .then(resolve).catch(reject)
                var v = document.createElement("video")
                v.crossOrigin = "anonymous";
                v.src = video.src;
                v.style.position="absolute";
                v.style.width = "50vw";
                v.style.height = "50vh";
                v.style.top = "50px";
                v.style.left = "50px";
                v.style.opacity = 0;
                v.style['pointer-events'] = 'none';
                if(video.currentTime)
                    v.currentTime = video.currentTime;
                document.body.appendChild(v);
                var _lst = function(){
                    if(v.readyState >= 3){
                        self.$hisport.options.logger.log("Video loaded, exporting...");

                        setTimeout(function(){
                            self.$refs.canvas.getCurrentFrameAsImage(v, sx, sy, sw, sh, 0, 0, sw * 2, sh * 2)
                                .then(function(data){
                                    document.body.removeChild(v);
                                    resolve(data);
                                })
                                .catch(function(err){
                                    document.body.removeChild(v);
                                    reject(err);
                                })
                            // try{
                            //     var canvas 		= document.createElement("canvas");
                            //     document.body.appendChild(canvas);
                            //     canvas.width 		= 640;
                            //     canvas.height 		= 480;
                            //     canvas.style.border 	= "10px solid red";
                            //     canvas.style.width 	= "640px";
                            //     canvas.style.height 	= "480px";
                            //     canvas.style.position 	= "absolute";
                            //     canvas.style.top 	= "50px";
                            //     canvas.style.left 	= "50px";

                            //     var ctx 		= canvas.getContext("2d");
                            //     ctx.drawImage(v,0,0)
                            // }catch(ex){
                            //     reject();
                            // }
                        }, 500);
                        //
                        v.removeEventListener("loadeddata", _lst)
                    }
                }
                v.addEventListener("loadeddata", _lst)
            });
        },
        toggleDraw: function(){
            if(this.draw_mode){
                this.draw_mode = false;
                return;
            }
            this.toggleTagList();
            this.pause();
            this.draw_mode = true;
            var self = this;
            this.getCurrentFrameAsImage()
            .then(function(){
                self.$hisport.options.logger.info("Created")
            })
            .catch(function(error){
                self.$hisport.options.logger.error("ToggleDraw", error)
            })
        },
        drawSave: function(arg){
            var media = this.$refs.canvas.save(arg);
            this.$emit("draw", {
                media: media,
                x: this.manager.x,
                y: this.manager.y,
                z: this.manager.z,
                ts: this.current_time
            })
        },
        zoomIn: function(){
            this.actual_zoom = this.manager.set({z: this.manager.z + 1 }).z;
        },
        zoomOut: function(){
            this.actual_zoom = this.manager.set({z: this.manager.z - 1 }).z;
        },
        zoomTo: function(value){
            this.actual_zoom = this.manager.set({z: value }).z;
        },
        drawUndo: function(arg){
            return this.$refs.canvas.undo(arg);
        },
        drawRedo: function(arg){
            return this.$refs.canvas.redo(arg);
        },
        drawColor: function(arg){
            return this.$refs.canvas.changeColor(arg);
        },
        drawSize: function(arg){
            return this.$refs.canvas.changeLineWidth(arg);
        },
        drawMode: function(arg){
            return this.$refs.canvas.changeMode(arg);
        },
    //#endregion
    //#region "Markers"
        getMarkers: function(){
            if(!this.manager) return [];
            return this.manager.getMarkers();
        },
        updateMarkers: function(){
            var self = this;
            this.selectedTag.markers.splice(0);
            this.manager.getMarkers().forEach(function(m){
                self.$set(self.selectedTag.markers, self.selectedTag.markers.length, m);
            });
        },
        addMarker: function(m){
            if(!this.manager) return [];
            this.manager.addMarker(m);
            return this.updateMarkers();
        },
        removeMarkerById: function(mid){
            if(!this.manager) return [];
            this.manager.removeMarkerById(mid);
            this.updateMarkers();
        },
        gotoMarkerById: function(mid){
            if(!this.manager) return [];
            var marker = this.manager.getMarkers().find(function(x){ return x.id == mid; });
            if(marker){
                var ele = this.getActiveElement();
                ele.currentTime = marker.ts;
            }
        },
    //#endregion
    },
    computed: {
        mode: function(){
            if(!this.selectedTag)   return MODES.IDLE;
            if(this.editMode)       return MODES.MARKER;
            if(this.draw_mode)      return MODES.DRAW
            return MODES.TAG;
        },
        percentage: function(){
            return this.computePercentage(this.current_time);
        },
        selected_tag_percentage: function(){
            return this.computePercentageInSelectedTag(this.current_time);
        }
    },
    watch: {
        event:function(){
            this.setup()
        },
        selectedTag: function(){
            var ele = this.getActiveElement();
            if(this.selectedTag){
                if(this.manager)
                    this.manager.clearMarkers()
                this.$set(this.selectedTag, "markers", []);
                this.addMarker({ts: this.selectedTag.start_time, locked: true});
                // this.addMarker({ts: ((this.selectedTag.end_time - this.selectedTag.start_time)/2) + this.selectedTag.start_time, locked: false});
                this.addMarker({ts: this.selectedTag.end_time, locked: true});
                if(this.$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG){
                    if(Array.isArray(this.event.clips)){
                        var self = this;
                        var clip = this.event.clips.find(function(x){ return x.id_tag == self.selectedTag.id });
                        if(clip){
                            console.log("Changing video to clip", clip.id)
                            ele.currentTime = 0;
                            this.changeCurrentTime(0);
                            this.available_resolutions = [];
                            this.changeVideo(clip);
                        }else{
                            console.warn("No clip for tag", this.selectedTag.id);
                        }
                    }else{
                        console.warn("No clips for event");
                    }
                }else{
                    ele.currentTime = this.selectedTag.start_time;
                    this.changeCurrentTime(this.selectedTag.start_time);
                }
            }else if(this.$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG){
                ele.currentTime = 0;
                this.changeCurrentTime(0);
                this.available_resolutions = [];
                this.changeVideo(this.event.video);
            }
        },
        editingTag: function(tag){
            console.log("editingTag", tag)
            if(tag){
                this.computeEditingTag();
                var ele = this.getActiveElement();
                ele.currentTime = tag.start_time;
            }
        }
    }
}
</script>
<style>
.table-manager-debug{
    display: none;
    position: absolute;
    z-index: 9999;
    background: rgba(255,255,255,.3);
    top: 0;
    color: black;
    right: 0;
    bottom: 0;
    padding: 10px;
}
</style>